<template>
	<div>
		<v-container align="center" justify="center" class="pa-5 pb-0">
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-1 text-center text-wrap">
						<h1>{{ getLabel('educationSectionHeader', 'Education') }}</h1>
					</v-list-item-title>
					<v-list-item-subtitle class="text-center text-wrap">
						{{ getLabel('educationSectionDescription', 'For increased credibility, tell us about your qualifications.') }}
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</v-container>

		<v-card-text align="center" justify="center" class="justify-center text-center pb-0 pm-0">
			<qualifications-form :solo="false"></qualifications-form>
		</v-card-text>
	</div>
</template>

<script>
import store from '@/store';

import QualificationsForm from '@/components/locum/profile/QualificationsForm.vue';

export default {
	components: {
		QualificationsForm,
	},
	props: {
		show: {
			default: false,
			type: Boolean,
		},
	},
	data: () => ({
		idfile: null,
		step: 'education-step',
	}),

	created() {
		document.getElementById('app').scrollIntoView();
	},

	methods: {
		checkStep(user) {
			const { qualification, institution, year_qualified } = user.qualifications;

			if (qualification?.length > 2 && institution?.length > 2 && year_qualified) {
				store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
				return true;
			} else {
				return false;
			}
		},
		getStep() {
			return 'education-step';
		},
		getText() {
			return 'education';
		},
	},
};
</script>
